var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeykReq(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165 0C108.115 0 62 46.115 62 103v294c0 56.885 46.115 103 103 103h91.859C227.808 469.201 210 427.68 210 382c0-94.993 77.007-172 172-172 19.606 0 38.445 3.28 56 9.322V103C438 46.115 391.885 0 335 0zm-30 112c0-14.912 12.088-27 27-27h138c14.912 0 27 12.088 27 27s-12.088 27-27 27H162c-14.912 0-27-12.088-27-27zm27 63c-14.912 0-27 12.088-27 27s12.088 27 27 27h38c14.912 0 27-12.088 27-27s-12.088-27-27-27z",
    fill: "#111f3e",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382 500c-8.334 0-16.466-.864-24.311-2.507C304.183 486.286 264 438.836 264 382c0-65.17 52.83-118 118-118 20.266 0 39.338 5.109 56 14.109 36.918 19.942 62 58.987 62 103.891 0 65.17-52.83 118-118 118zm-22.908-136.549c-10.544-10.544-27.64-10.544-38.184 0s-10.544 27.64 0 38.184l30.051 30.05c10.544 10.544 27.639 10.544 38.184 0l57.543-57.543c10.544-10.544 10.544-27.64 0-38.184s-27.64-10.544-38.184 0l-38.451 38.452z",
    fill: "#111f3e",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeykReq);
export default __webpack_public_path__ + "static/media/PeykReq.8351d23ac47762d5e0943d3a7ff9109f.svg";
export { ForwardRef as ReactComponent };